import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getVmiLocationState } from "@insite/client-framework/Store/Data/VmiLocations/VmiLocationsSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Tag, { horizontalStyles, TagPresentationProps } from "@insite/mobius/Tag";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import setIsBackordered from "@preferredMedical/Store/Pages/OrderHistory/Handlers/SetIsBackordered";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const vmiLocationId = state.pages.orderHistory.getOrdersParameter.vmiLocationId;

    return {
        filtersOpen: state.pages.orderHistory.filtersOpen,
        getOrdersParameter: state.pages.orderHistory.getOrdersParameter,
        vmiLocationState: vmiLocationId ? getVmiLocationState(state, vmiLocationId) : null,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
    setIsBackordered,
};

export interface OrderHistorySearchTagsStyles {
    appliedFiltersContainer?: InjectableCss;
    appliedFilterTag?: TagPresentationProps;
}

export const orderHistorySearchTagsStyles: OrderHistorySearchTagsStyles = {
    appliedFiltersContainer: { css: horizontalStyles },
};

const styles = orderHistorySearchTagsStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const orderHistorySearchTags = ({ getOrdersParameter, updateSearchFields, setIsBackordered }: Props) => {
    const fieldRemoveHandler = (fieldName: string, value = "") => {
        updateSearchFields({ [fieldName]: value });
    };

   
    if ( getOrdersParameter.vmiOrdersOnly === false || (`${getOrdersParameter.vmiOrdersOnly}`) === "false" ) {
        setIsBackordered({ isBackordered: false });
    }
    else if(getOrdersParameter.vmiOrdersOnly === undefined || getOrdersParameter.vmiOrdersOnly === null) {
        setIsBackordered({ isBackordered: false });
    }else {
        setIsBackordered({ isBackordered: true });
    }

    return (
        <StyledWrapper {...styles.appliedFiltersContainer}>
            {getOrdersParameter.vmiOrdersOnly && (
                <Tag
                    {...styles.appliedFilterTag}
                    onDelete={() => {
                        fieldRemoveHandler("vmiOrdersOnly");
                    }}
                >
                    {`${translate("Show Open Backorders")}: ${getOrdersParameter.vmiOrdersOnly}`}
                </Tag>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(orderHistorySearchTags),
    definition: {
        group: "Order History",
        displayName: "BackOrders Tag",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
